import { getLocale } from '#/paraglide/runtime'

const intlLocale = () => (getLocale() === 'id' ? 'id-ID' : 'en-US')

export const fmtNumber = (n: number) => new Intl.NumberFormat(intlLocale()).format(n)

export const fmtCompact = (n: number) =>
  new Intl.NumberFormat(intlLocale(), { notation: 'compact', maximumFractionDigits: 1 }).format(n)

export const fmtPercent = (ratio: number) => `${Math.round(ratio * 100)}%`

export const fmtCurrency = (amount: number, currency: 'IDR' | 'USD') =>
  new Intl.NumberFormat(currency === 'IDR' ? 'id-ID' : 'en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: currency === 'IDR' ? 0 : 2,
  }).format(amount)

/** Short currency for price cards: "Rp 66k" / "$6" */
export const fmtPriceShort = (amount: number, currency: 'IDR' | 'USD') => {
  if (currency === 'IDR') {
    if (amount >= 1000) return `Rp ${Math.round(amount / 1000)}k`
    return `Rp ${amount}`
  }
  return `$${amount % 1 === 0 ? amount : amount.toFixed(2)}`
}

export const fmtDate = (d: string | Date, opts: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short', year: 'numeric' }) =>
  new Intl.DateTimeFormat(intlLocale(), opts).format(typeof d === 'string' ? new Date(d) : d)

export const fmtDateTime = (d: string | Date) =>
  fmtDate(d, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })

/** "3 min ago" / "in 2 days" style relative time, locale-aware. */
export const fmtRelative = (d: string | Date | null | undefined) => {
  if (!d) return '—'
  const t = (typeof d === 'string' ? new Date(d) : d).getTime()
  const diff = (t - Date.now()) / 1000
  const abs = Math.abs(diff)
  const rtf = new Intl.RelativeTimeFormat(intlLocale(), { numeric: 'auto' })
  if (abs < 60) return rtf.format(Math.round(diff), 'second')
  if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute')
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour')
  if (abs < 86400 * 30) return rtf.format(Math.round(diff / 86400), 'day')
  if (abs < 86400 * 365) return rtf.format(Math.round(diff / (86400 * 30)), 'month')
  return rtf.format(Math.round(diff / (86400 * 365)), 'year')
}
